export const TAXA_OPTIONS = [
  { value: 'all', label: 'All taxa' },
  { value: 'mammals', label: 'Mammals' },
  { value: 'reptiles', label: 'Reptiles' },
  { value: 'birds', label: 'Birds' },
  { value: 'fish', label: 'Fish' },
  { value: 'invertebrates', label: 'Invertebrates' },
];

const TAXA_KEYWORDS = {
  mammals: [
    'whale',
    'dolphin',
    'porpoise',
    'otter',
    'seal',
    'sea lion',
    'manatee',
    'dugong',
    'mammal',
  ],
  reptiles: ['turtle', 'tortoise', 'terrapin', 'reptile', 'snake', 'lizard', 'crocodile', 'alligator'],
  birds: [
    'bird',
    'pelican',
    'gull',
    'tern',
    'cormorant',
    'albatross',
    'shearwater',
    'petrel',
    'egret',
    'heron',
  ],
  fish: [
    'fish',
    'tuna',
    'marlin',
    'snapper',
    'grouper',
    'shark',
    'ray',
    'bait',
    'jack',
    'runner',
    'pelagic',
    'reef',
  ],
  invertebrates: ['lobster', 'octopus', 'squid', 'jelly', 'shrimp', 'crab', 'urchin', 'invertebrate', 'crustacean'],
};

export function inferTaxaBucket(input) {
  const text = Array.isArray(input) ? input.join(' ') : String(input || '');
  const normalized = text.toLowerCase();

  for (const [bucket, keywords] of Object.entries(TAXA_KEYWORDS)) {
    if (keywords.some((keyword) => normalized.includes(keyword))) {
      return bucket;
    }
  }

  return 'other';
}

export function filterSpeciesGroupsByTaxa(groups, taxa = 'all') {
  const source = Array.isArray(groups) ? groups : [];
  const mapped = source.map((label) => ({
    label,
    taxa: inferTaxaBucket(label),
  }));

  if (!taxa || taxa === 'all') return mapped;
  return mapped.filter((item) => item.taxa === taxa);
}

export function eventMatchesTaxa(event, taxa = 'all') {
  if (!taxa || taxa === 'all') return true;
  const bucket = inferTaxaBucket([
    event?.title,
    event?.summary,
    event?.event_type,
    Array.isArray(event?.tags) ? event.tags.join(' ') : '',
  ]);
  return bucket === taxa;
}
